import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";

import { routes } from "routes.js";
import pdfCapodanno from "menu_capodanno_24.pdf";

import "./header.css";

import logo from "images/bi/rabarbaro_badge4_RGB_bianco blu.png";

let location;

const Header = ({ title }) => {
	const [scroll, setScroll] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [isHovered, setIsHovered] = useState(false);

	location = useLocation();

	useEffect(() => {
		window.addEventListener("scroll", () => {
			setScroll(window.scrollY > 50);
		});
	}, []);

	useEffect(() => {
		setIsOpen(false);
	}, [location]);

	const renderRoutes = () =>
		routes.map((route) => {
			// se è una route con figli
			if (route.visible) {
				return (
					<>
						{route.hasChild ? (
							<li
								key={route.key}
								className={`dropdown ${isHovered ? "open" : ""}`}
								onMouseEnter={() => setIsHovered(true)}
								onMouseLeave={() => setIsHovered(false)}>
								<a key={route.key + "-link"} className="dropdown-toggle">
									{route.linkName}
								</a>
								<ul class="dropdown-menu ">
									<li>
										<Link to="/pranzi">Pranzi</Link>
									</li>
									<li>
										<Link to="/cene">Alla carta</Link>
									</li>
								</ul>
							</li>
						) : (
							<li key={route.key}>
								<Link key={route.key + "-link"} to={route.route}>
									{route.linkName}
								</Link>
							</li>
						)}
					</>
				);
			}

			return null;
		});

	return (
		<>
			<nav
				className={
					location.pathname?.indexOf("/rabarbaro") > -1 ||
					location.pathname?.indexOf("/rabar") > -1
						? scroll
							? "navbar navbar-custom navbar-fixed-top"
							: "navbar navbar-custom navbar-fixed-top navbar-transparent"
						: "navbar navbar-custom navbar-fixed-top"
				}
				role="navigation">
				<div className="container">
					<div className="navbar-header">
						<Link target="_self" to="/home">
							<img className="logo" src={logo} alt={"Rabarbaro"} />
						</Link>
						<div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
							<i className={isOpen ? "fa fa-times" : "fa fa-bars"}></i>
						</div>
					</div>

					<div className={isOpen ? "" : "collapse navbar-collapse"}>
						<ul className="nav navbar-nav navbar-right">
							{renderRoutes()}
							{/* <li>
								<Link to={pdfCapodanno} target="_blank">
									Menù di Capodanno
								</Link>
							</li> */}
						</ul>
					</div>
				</div>
			</nav>
		</>
	);
};

export default Header;
